import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SkuRule } from '../../channels.model';

@Component({
  selector: 'app-channel-sku-rules-tab',
  standalone: false,
  templateUrl: './channel-sku-rules-tab.component.html',
  styleUrl: './channel-sku-rules-tab.component.scss'
})
export class ChannelSkuRulesTabComponent {
  @Input() skuRules: SkuRule[] = [];
  @Output() skuRulesChange = new EventEmitter<SkuRule[]>();

  showAddSkuForm = false;
  newSkuRule: { type: SkuRule['type']; code: string; label: string } = {
    type: 'ALLOW', code: '', label: ''
  };
  newSkuError = false;

  get allowedSkuCount(): number {
    return this.skuRules.filter(r => r.type !== 'RESTRICT').length;
  }

  get restrictedSkuCount(): number {
    return this.skuRules.filter(r => r.type === 'RESTRICT').length;
  }

  openAddSkuForm(): void {
    this.showAddSkuForm = true;
    this.newSkuRule = { type: 'ALLOW', code: '', label: '' };
    this.newSkuError = false;
  }

  addSkuRule(): void {
    this.newSkuError = !this.newSkuRule.code.trim() || !this.newSkuRule.label.trim();
    if (this.newSkuError) return;
    this.skuRulesChange.emit([...this.skuRules, {
      id: `sku-${Date.now()}`,
      type: this.newSkuRule.type,
      code: this.newSkuRule.code.toUpperCase().replace(/[^A-Z0-9-]/g, ''),
      label: this.newSkuRule.label.trim()
    }]);
    this.showAddSkuForm = false;
  }

  removeSkuRule(id: string): void {
    this.skuRulesChange.emit(this.skuRules.filter(r => r.id !== id));
  }
}
